import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { createLogin } from '../../app/login/login.slice';
import commonFunction from '../../Utils/commonFunction';
import Loader from '../Common/Loader';
import './login.css';
import { useTranslation } from "react-i18next";

function Login() {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPassword, setShowPassword] = useState(false);
  const [verifyOtp, setVerifyOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState("");

  useEffect(() => {
    if (verifyOtp) {
      handleResendOTP();
    }
  }, [verifyOtp]);

  const handleResendOTP = async () => {
    try {
      setLoading(true);

      const email = formik.values.email;
      const res = await commonFunction.reSendOtp(email);

      if (res.status === true) {
        toast.success("Ny kode tilsendt til mailen");

        setTimeout(() => {
          navigate("/verifyOtp", {
            state: { email }
          });
        }, 1000);
      } else {
        toast.error(`Something went wrong, ${res?.data?.message}`);
      }

    } catch (error) {
      toast.error("Failed to resend OTP");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    setVerifyOtp(false);
  }, [])

  const validationSchema = yup.object({
    email: yup.string().email('Ugyldig Email').required('Indtast din e-mailadresse.'),
    password: yup.string().required('Indtast din adgangskode.'),
  });


  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },

    onSubmit: async (values) => {

      try {
        setLoading(true);
        setLoginError("");
        const response = await dispatch(createLogin(values));
        if (response.payload.status) {
          toast.success(response.payload.message);
          setLoading(false);
          window.location.reload(true)
        } else {
          setLoading(false);
          if (response.payload.data.Otpstatus === false) {
            setVerifyOtp(true);
          } else {
            setVerifyOtp(false);
          }
          setLoginError(response?.payload?.message || "Please wait!! Something went wrong!!");
        }
      }
      catch (error) {
        setLoading(false);
        toast.error('Please wait!! Something went wrong !!');
      }

    },
    validationSchema
  });

  if (loading) {
    return (
      <Loader />
    )
  }

  return (
    <main>
      <section className="login-sec wow pulse">
        <div className="container">
          <div className="login-inner">
            <div className="row">
              <div className="col-md-6">
                <form className="form_elements" onSubmit={formik.handleSubmit}>
                  <div className="form-title">
                    <h2> {t("auth.login")}</h2>
                  </div>
                  <div className="form-group">
                    <div className="label_wrap">
                      <label htmlFor="email">Email ID</label>
                      <abbr>*</abbr>
                    </div>
                    <input
                      type="email"
                      className={`form-control ${formik.touched.email && formik.errors.email ? "input-error" : ""}`}
                      id="email"
                      placeholder="Email"
                      onChange={(e) => {
                        formik.handleChange(e);
                        setLoginError("");
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="error-message-login">
                        <span className="error-dot"></span>
                        <span>{formik.errors.email}</span>
                      </div>
                    ) : null}
                  </div>
                  <div className="form-group">
                    <div className="label_wrap">
                      <label htmlFor="password">Adgangskode</label>
                      <abbr>*</abbr>
                    </div>
                    <div className="d-flex">

                      <input
                        type={showPassword ? "text" : "password"}
                        className={`form-control ${formik.touched.password && formik.errors.password ? "input-error" : ""}`}
                        id="password"
                        name="password"
                        placeholder="Adgangskode"
                        onChange={(e) => {
                          formik.handleChange(e);
                          setLoginError("");
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.password}
                      />
                      <div className="input-group-append">
                        <span className="input-group-text" style={{ height: '45px', cursor: 'pointer' }}>
                          <i
                            className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} toggle-password-icon`}
                            aria-hidden="true"
                            onClick={() => { setShowPassword(!showPassword) }}
                            style={{ color: '#EE4D1A' }}
                          ></i>
                        </span>
                      </div>
                    </div>
                    {formik.touched.password && formik.errors.password ? (
                      <div className="error-message-login">
                        <span className="error-dot"></span>
                        <span>{formik.errors.password}</span>
                      </div>
                    ) : null}
                  </div>

                  <div className="form-group d-flex justify-content-between">
                    <div className="form-check form_check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="gridCheck"
                      />
                      <label className="form-check-label" htmlFor="gridCheck">
                        Husk Mig
                      </label>
                    </div>
                    <div className="forgotPass">
                      <Link to="/forgot-password">
                        Glemt Adgangskode?
                      </Link>
                    </div>
                  </div>

                  {loginError && (
                    <div className="login-error-message">
                      <div className="login-error-icon">
                        <i className="fa fa-exclamation" aria-hidden="true"></i>
                      </div>

                      <div className="login-error-text">
                        <strong>{loginError}</strong>
                      </div>
                    </div>
                  )}
                  <div className="btn_submit">
                    <button type="submit" className="btn btn-1 w-100">
                      Login
                    </button>
                  </div>
                  {loginError && (
                    <div className="login-error-footer">

                      <div className="login-divider">
                        <span>eller</span>
                      </div>

                      <div className="login-contact">
                        <span className="contact-icon">
                          <i className="fa fa-question" aria-hidden="true"></i>
                        </span>

                        <span>
                          Har du problemer med at logge ind?{" "}
                          <Link to="/contact">
                            Kontakt os
                          </Link>
                        </span>
                      </div>


                    </div>
                  )}

                  <div className="login-bottom-divider"></div>
                  <div className="login-register">
                    <span>
                      Har du ikke en konto?{" "}
                      <NavLink to="/signup">
                        Opret bruger
                      </NavLink>
                    </span>
                  </div>
                  {/* {
                    verifyOtp && (
                      <Link onClick={handleResendOTP} style={{ cursor: 'pointer', marginTop: '10px' }}>
                        Resend OTP
                      </Link>
                    )
                  } */}
                </form>
              </div>
              <div className="col-md-6">
                <div className="login-img">
                  {/* Your other content goes here */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Login;
